import React from "react";
import { motion } from "framer-motion";

const PLATFORMS = [
  {
    name: "Zomato",
    href: "https://link.zomato.com/xqzv/rshare?id=13031204330563f60",
    color: "from-[#E23744] to-[#cb2d3a]",
    hoverColor: "hover:shadow-red-400/30",
    logo: "/assets/zomato-logo.svg",
    tagline: "Order on Zomato",
  },
  {
    name: "Swiggy",
    href: "https://sds.swig.gy/39zzMwmnZCP",
    color: "from-[#FC8019] to-[#e06d0d]",
    hoverColor: "hover:shadow-orange-400/30",
    logo: "/assets/swiggy-logo.svg",
    tagline: "Order on Swiggy",
  },
];

const FadeInUp = ({ children, delay = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}
    transition={{ duration: 0.6, delay }}
  >
    {children}
  </motion.div>
);

export default function OrderOnline() {
  return (
    <section
      id="order"
      className="section-padding bg-beige"
      aria-label="Order Online"
    >
      <div className="max-w-4xl mx-auto text-center">
        <FadeInUp>
          <p className="text-redAccent font-semibold tracking-widest uppercase text-xs mb-3">
            Delivery
          </p>
          <h2 className="section-heading">Order Online</h2>
          <div className="accent-divider mx-auto" />
          <p className="text-gray-500 max-w-lg mx-auto mb-10 text-base md:text-lg">
            Craving pahadi-style comfort food? Get it delivered to your doorstep
            through your favourite platform.
          </p>
        </FadeInUp>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          {PLATFORMS.map((platform, i) => (
            <FadeInUp key={platform.name} delay={0.15 * (i + 1)}>
              <a
                href={platform.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Order from ${platform.name}`}
                className={`group relative flex items-center gap-4 px-8 py-5 rounded-2xl bg-gradient-to-r ${platform.color} text-white shadow-lg ${platform.hoverColor} hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 min-w-[260px]`}
              >
                <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center shrink-0 shadow-inner">
                  <img
                    src={platform.logo}
                    alt={`${platform.name} logo`}
                    className="w-8 h-8 object-contain"
                  />
                </div>
                <div className="text-left">
                  <span className="block text-lg font-bold leading-tight">
                    {platform.tagline}
                  </span>
                  <span className="block text-white/70 text-sm mt-0.5">
                    Fast delivery &middot; Great offers
                  </span>
                </div>
                <svg
                  className="w-5 h-5 ml-auto opacity-60 group-hover:translate-x-1 group-hover:opacity-100 transition-all duration-200"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </a>
            </FadeInUp>
          ))}
        </div>

        <FadeInUp delay={0.5}>
          <p className="mt-10 text-sm text-gray-400">
            Or call us directly at{" "}
            <a
              href="tel:+919373309484"
              className="text-redAccent font-medium hover:underline"
            >
              +91 93733 09484
            </a>{" "}
            for takeaway orders
          </p>
        </FadeInUp>
      </div>
    </section>
  );
}
